export default __webpack_public_path__ + "media/zurb/img/case-study-libdib/libdib-bg-7cd5f4fa67b8413769231b7e78d2f67a.png";